import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type { components } from '@/api/schema'
import { useAuthenticatedClient } from '@/api/queries'

export type SalesOverview = components['schemas']['SalesOverviewRead']
export type SalesOverviewProject = components['schemas']['SalesOverviewProjectRead']
export type Outreach = SalesOverviewProject['outreach']

export function useSalesOverview(salesPersonId?: number) {
  const getClient = useAuthenticatedClient()
  return useQuery({
    queryKey: ['sales-overview', { salesPersonId }],
    queryFn: async () => {
      const client = await getClient()
      const { data, error } = await client.GET('/dashboard/sales-overview', {
        params: { query: { sales_person_id: salesPersonId } },
      })
      if (error) throw error
      return data!
    },
    placeholderData: keepPreviousData,
  })
}
